import React from "react";
import { Link, useLocation } from "react-router-dom"; 
import { ArrowForwardIos } from "@mui/icons-material";
function Breadcrumbs() {
  const location = useLocation();
  const vPathName = location.pathname;
  return (
    <div className="container-fluid ps-0">
      {vPathName === "/BarcodeScanning" ? (
        <div>
          <span
            className="breadcrumb-not-active "
            //  style={{ fontSize: '1rem', textDecorationLine: 'underline' }}
          >
            Barcode Scanning{" "}
          </span>
        </div>
      )   : (
        <></>
      )}
    </div>
  );
}
export default Breadcrumbs;
